import React from "react"
import MySelectFormField from "@common-components/fields/MySelectFormField"
import MySelectCreatableFormField from "@common-components/fields/MySelectCreatableFormField"
import MyAlert from "@common-utils/MyAlert"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_REPAS_MIDI } from "@common-constants/*"

export const NdfMealSection = ({ helpers, validationSchema }: any) => {
     if (helpers.values.categorie !== CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_REPAS_MIDI) return null

     return (
          <>
               <MySelectFormField
                    formikProps={helpers}
                    validationSchema={validationSchema}
                    label={<span className={"required"}>Type de repas</span>}
                    name={"repasSeulOuEnGroupe"}
                    options={[
                         { value: "REPAS_MIDI_SEUL", label: "Repas seul" },
                         { value: "REPAS_MIDI_EN_GROUPE", label: "Repas en groupe" },
                    ]}
                    placeholder={"Choisissez si seul ou en groupe"}
                    classNameLabel={"col-lg-4"}
                    classNameField={"col-lg-8"}
                    classNameLayout={"mb-2"}
               />
               {helpers.values.repasSeulOuEnGroupe === "REPAS_MIDI_EN_GROUPE" && (
                    <div>
                         <div className="row d-flex justify-content-lg-end">
                              <div className={"mb-2 col-lg-8 px-lg-3"}>
                                   <MyAlert type={"primary"}>Saisissez Nom, Prénom et Société (si client).</MyAlert>
                              </div>
                         </div>
                         <MySelectCreatableFormField
                              formikProps={helpers}
                              validationSchema={validationSchema}
                              name={"invites"}
                              placeholder={"Saisissez les invités"}
                              classNameLabel={"col-lg-4"}
                              classNameField={"col-lg-8"}
                              classNameLayout={"mb-2"}
                         />
                    </div>
               )}
          </>
     )
}
